/**
 * Dependencies
 */
import Vue from 'vue'
import { get } from 'lodash'
import { getState } from './state'

/**
 * Set up the CAPEX modal context
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const SETUP_CAPEX_MODAL = (state, payload) => {
    Vue.set(state, 'form', payload.model)
    Vue.set(state, 'fresh', payload.fresh)
    state.existingContext.serializer = payload.type
    state.existingContext.index = payload.index
    state.showModal = true
}

/**
 * Update a CAPEX Form value
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const UPDATE_FORM_VALUE = (state, payload) => {
    let base = get(state, payload.base)
    base[payload.target] = payload.value
}

/**
 * Update the currently selected tab
 *
 * @param  {Object} state
 * @param  {String} tab
 * @return {Void}
 */
const CHANGE_TAB = (state, tab) => {
    state.currentTab = tab
}

/**
 * Reset the form model back to its original attributes
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const RESET_FORM = (state, payload) => {
    state.form = payload
    state.fresh = true
    state.showModal = true
}

/**
 * Add a cost to a relative capex item's state
 *
 * @param  {Obect} state
 * @param  {Obect} payload
 * @return {Void}
 */
const ADD_RELATIVE_COST = (state, id) => {
    if (!state.form.target_costs.includes(id)) {
        state.form.target_costs.push(id)
    }
}

/**
 * Remove a cost from a relative capex item's state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const REMOVE_RELATIVE_COST = (state, id) => {
    let idx = state.form.target_costs.findIndex(cost => cost === id)

    state.form.target_costs.splice(idx, 1)
}

/**
 * Replace spread object with new context
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const CALCULATE_NEW_SPREAD = (state, payload) => {
    state.form.spread = payload
}

/**
 * Modify a spread data value at a given index
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const UPDATE_SPREAD_VALUE = (state, payload) => {
    state.form.spread.data.splice(payload.index, 1, payload.value)
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

const SET_SAVING = state => {
    state.saving = true
}

const RESET_SAVING = state => {
    state.saving = false
}

const SET_FORM_ERRORS = (state, errors) => {
    state.errors = errors
}

const RESET_FORM_ERRORS = state => {
    state.errors = {}
}

const CLEAR_ERRORS = (state, key) => {
    state.errors = Object.keys(state.errors).reduce((sum, e) => {
        if (e !== key) {
            sum[e] = state.errors[e]
        }
        return sum
    }, {})
}

export default {
    CHANGE_TAB,
    RESET_FORM,
    RESET_STATE,
    SET_SAVING,
    CLEAR_ERRORS,
    RESET_SAVING,
    SET_FORM_ERRORS,
    RESET_FORM_ERRORS,
    ADD_RELATIVE_COST,
    UPDATE_FORM_VALUE,
    SETUP_CAPEX_MODAL,
    UPDATE_SPREAD_VALUE,
    REMOVE_RELATIVE_COST,
    CALCULATE_NEW_SPREAD
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/form/capex/mutations.js